import React, { Component } from 'react';

class LoadingScreen extends Component {
  render() {
    return <div>Loading...</div>;
  }
}

export default LoadingScreen;
